var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDatabase = function SvgDatabase(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "#000"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#database_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M10.5 2.5C10.5 3.328 8.485 4 6 4s-4.5-.672-4.5-1.5m9 0C10.5 1.672 8.485 1 6 1s-4.5.672-4.5 1.5m9 0v7c0 .83-2 1.5-4.5 1.5s-4.5-.67-4.5-1.5v-7m9 3.5c0 .83-2 1.5-4.5 1.5S1.5 6.83 1.5 6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "database_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h12v12H0z"
  })))));
};
export default SvgDatabase;